// First, create an interface for the component props
import { IServiceProvider } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import Tenant from 'src/components/Tenant';
import { adaptToCategoryPills } from 'src/pages/ServiceRequest/helpers';
import Avatar from 'src/components/Avatar';
import React from 'react';

interface ServiceProviderListProps {
  providers: IServiceProvider[];
  handleContactSelect: (provider: IServiceProvider) => void;
  from: string;
}

// The reusable component for rendering a list of service providers
const ServiceProviderList = ({
  providers,
  handleContactSelect,
  from,
}: ServiceProviderListProps) => {
  if (!providers || providers.length === 0) {
    return null;
  }

  return (
    <>
      {providers.map((contact: IServiceProvider, x: number) => (
        <button
          className="contactPicker__tenant"
          key={contact.userId || x}
          onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            e.preventDefault();
            handleContactSelect(contact);
          }}
        >
          <Tenant
            headline={`${contact.firstname} ${contact.lastname}`}
            strapline={
              from === 'dashboard'
                ? `${contact.role} ${contact.servicesProvided !== null ? ' - ' + contact.servicesProvided : ''}`
                : contact.role
            }
            strapLineItemsListRole={`${contact.role}`}
            strapLineItemsList={adaptToCategoryPills(
              contact.servicesProvided || []
            )}
            avatar={
              <Avatar
                badge={
                  contact.role === 'Service Provider'
                    ? 'service-provider'
                    : 'property-manager'
                }
                url={contact.profileImage}
                size={undefined}
              />
            }
            company={contact.companyName}
          />
        </button>
      ))}
    </>
  );
};

export default ServiceProviderList;
